export default __webpack_public_path__ + "static/media/arrowdown.84e25d16.svg";